import { createChannel } from './genericChannel';
export { Subscriber, Publisher } from './genericChannel';
export const initChannels = (apiClient, validator) => ({
    'selfadjusts/{selfadjust_id}/ai/finished': (parameters) => { return createChannel(apiClient, validator, 'selfadjusts/{selfadjust_id}/ai/finished', parameters); },
});
